Drupal.behaviors.accessibilityTools = {
  attach(context) {
    once("accessibilityTools", ".accessibility-tools", context).forEach(() => {

      let isSpeaking = false;
      let utterance = null;

      const ttsBtn = document.querySelector('.acc-tts');
      if (ttsBtn) {
        ttsBtn.addEventListener('click', () => {
          if (!isSpeaking) {
            // Start reading
            utterance = new SpeechSynthesisUtterance(document.body.innerText);
            utterance.lang = document.documentElement.lang || 'en-US';
            speechSynthesis.speak(utterance);
            isSpeaking = true;

            utterance.onend = () => {
              isSpeaking = false;
            };
          } else {
            // Stop reading
            speechSynthesis.cancel();
            isSpeaking = false;
          }
        });
      }

      let size = 100; // base font size = 100%

      // Zoom In
      document.querySelector('.acc-zoom-in')?.addEventListener('click', () => {
        size += 10;
        document.documentElement.style.fontSize = size + '%';
      });

      // Zoom Out
      document.querySelector('.acc-zoom-out')?.addEventListener('click', () => {
        size -= 10;
        if (size < 50) size = 50; // Limit minimum size
        document.documentElement.style.fontSize = size + '%';
      });

      // -------------------------------
      // 3. High Contrast Toggle
      // -------------------------------
      document.querySelector('.acc-contrast')?.addEventListener('click', () => {
        document.documentElement.classList.toggle('high-contrast');
      });

    });
  }
};
